import Swal from "sweetalert2";
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

const Toast = MySwal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 1500,
  timerProgressBar: true,
});

export class AlertToast {
  public static success = async () => {
    await Toast.fire({
      icon: "success",
      title: "Success",
    });
  };

  public static failed = async () => {
    await Toast.fire({
      icon: "error",
      title: "Error",
    });
  };
};

export const SuccessToast = async (message: string | HTMLElement | JQuery | undefined) => {
  await Toast.fire({
    icon: "success",
    title: message,
    timer: 3000,
  });
}

export const InfoToast = (message: string | HTMLElement | JQuery | undefined) => {
  Toast.fire({
    icon: "info",
    title: message,
    timer: 3000,
  });
}

export const ErrorToast = (message: string | HTMLElement | JQuery | undefined) => {
  Toast.fire({
    icon: "error",
    title: message,
    timer: 3000,
  });
}
